import React from "react";

type Props = {};

const BillingConf = (props: Props) => {
  return <>Billing Confirmation Widget (NOT READY)</>;
};

export default BillingConf;
